/* eslint-disable react/no-multi-comp */
import React from 'react';
import { matchPath, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { List, Typography } from '@mui/material';

import { NavigationListItem } from './components';

const NavigationList = ({items, ...rest}) => (
  <List sx={{py: 0, width: '100%'}}>
    { items.map((item, idx) => createChildItem({ idx, item, ...rest })) }
  </List>
);

NavigationList.propTypes = {
  depth: PropTypes.number,
  items: PropTypes.array,
};

const createChildItem = ({idx, loc, item, brief, depth}) => {
  if (item.children) {
    const open = matchPath({ path: item.href, end: false }, loc.pathname);
    const href = brief ? (item.children[0]?.href || item.href) : item.href;

    return (
      <NavigationListItem
        key={idx}
        active={Boolean(open)}
        depth={depth}
        brief={brief}
        href={href}
        icon={item.icon}
        label={item.label}
        open={Boolean(open)}
        title={item.title}
      >
        {!brief && <NavigationList
          depth={depth + 1}
          items={item.children}
          loc={loc}
        />}
      </NavigationListItem>
    );
  } else {
    const end = item.end ?? true;
    const active = matchPath({ path: item.href, end }, loc.pathname);

    return (
      <NavigationListItem
        key={idx}
        active={Boolean(active)}
        depth={depth}
        brief={brief}
        end={end}
        href={item.href}
        icon={item.icon}
        label={item.label}
        title={item.title}
      />
    );
  }
};

const Navigation = ({title, items, brief, component: Component, ...rest}) => {
  const loc = useLocation();

  return (
    <Component
      {...rest}
      style={{marginBottom: 16}}
    >
      {title && <Typography variant="overline">{title}</Typography>}
      <NavigationList
        depth={0}
        items={items}
        brief={brief}
        loc={loc}
      />
    </Component>
  );
};

Navigation.propTypes = {
  component: PropTypes.any,
  items: PropTypes.array.isRequired,
  brief: PropTypes.bool,  // can only using without nested items
  title: PropTypes.string
};

Navigation.defaultProps = {
  component: 'nav'
};

export default Navigation;
